module.exports = __webpack_public_path__ + "748fa5c717d9bf50813f28a5ed5a0c8f.svg";